// extracted by mini-css-extract-plugin
export default {"signin":"signin_signin__fWCgT","col":"signin_col__32xm-","center":"signin_center__0essp","container-form":"signin_container-form__WThjY"};